 // Case Study page data structure
 export interface CaseStudyPage {
   slug: string;
   seoKey: string;
   title: string;
   subtitle: string;
   description: string;
   canonicalUrl: string;
   keywords: string;
   breadcrumbLabel: string;
   publishDate: string;
   author: string;
   category: string;
   // Component keys for dynamic rendering
  componentSet: "big-green-egg-head" | "verbaende-regionalverband" | "marketing-2hm" | "vertrieb-ihr-hoergeraet";
}

export const caseStudyPages: CaseStudyPage[] = [
  {
    slug: "online-shops-e-commerce/big-green-egg-head",
    seoKey: "caseStudyBgeh",
    title: "Big Green Egg Head Case Study – WhatsApp AI & Shop-Integration | Chathero",
    subtitle: "340% mehr Beratungsgespräche durch WhatsApp AI",
    description: "Erfahren Sie, wie Big Green Egg Head mit Chatheros WhatsApp AI Agent und Shop-Integration die Beratungsqualität um 340% steigerte.",
    canonicalUrl: "https://chathero.ai/case-studies/online-shops-e-commerce/big-green-egg-head",
    keywords: "Big Green Egg, Case Study, WhatsApp Chatbot, E-Commerce Integration, BBQ Beratung, Online Shop",
    breadcrumbLabel: "Big Green Egg Head",
    publishDate: "2025-01-15",
    author: "Chathero Team",
    category: "Online Shops / E-Commerce",
    componentSet: "big-green-egg-head",
  },
  {
    slug: "verbaende/customer-support",
    seoKey: "caseStudyVerbaende",
    title: "Regionalverband Case Study – 87% Anfragen automatisiert mit KI-Wissensbasis | Chathero",
    subtitle: "87% aller Mitgliederanfragen automatisiert beantwortet",
    description: "Erfahren Sie, wie ein regionaler Wirtschaftsverband über 10.000 Seiten Fachwissen KI-gestützt aufbereitet und den Verwaltungsaufwand um 62% reduziert hat.",
    canonicalUrl: "https://chathero.ai/case-studies/verbaende/customer-support",
    keywords: "Verband Case Study, Wissensbasis KI, Mitgliederservice Automatisierung, Knowledge Base, Verwaltung digitalisieren",
    breadcrumbLabel: "Customer Support",
    publishDate: "2025-06-01",
    author: "Chathero Team",
    category: "Verbände & öffentliche Träger",
    componentSet: "verbaende-regionalverband",
  },
  {
    slug: "marketing",
    seoKey: "caseStudyMarketing",
    title: "2HM BS Case Study – Conversational Ads & KI-Lead-Generierung | Chathero",
    subtitle: "187% mehr Conversions durch Conversational Ads mit AI Chat",
    description: "Erfahren Sie, wie die Agentur 2HM BS mit Conversational Ads und Chathero AI die Cost-per-Lead um 64% senkte und die Lead-Qualität verdreifachte.",
    canonicalUrl: "https://chathero.ai/case-studies/marketing",
    keywords: "Conversational Ads, Lead-Generierung, Marketing Automation, AI Chat, Cost-per-Lead, Performance Marketing",
    breadcrumbLabel: "Marketing",
    publishDate: "2025-09-01",
    author: "Chathero Team",
    category: "Marketing & Lead-Generierung",
    componentSet: "marketing-2hm",
  },
  {
    slug: "vertrieb",
    seoKey: "caseStudyVertrieb",
    title: "ihr-hoergeraet.de Case Study – KI-Hörberatung & Akustiker-Lead-Generierung | Chathero",
    subtitle: "240% mehr Akustiker-Leads durch KI-Beratung & integrierte Arztsuche",
    description: "Erfahren Sie, wie ihr-hoergeraet.de mit Chathero AI die Akustiker-Suche, HNO-Vermittlung und Fach-FAQ automatisiert und die Lead-Generierung um 240% gesteigert hat.",
    canonicalUrl: "https://chathero.ai/case-studies/vertrieb",
    keywords: "Hörgeräte, Akustiker Lead-Generierung, HNO-Suche, AI Beratung, Conversational AI, Vertrieb Automatisierung",
    breadcrumbLabel: "Vertrieb",
    publishDate: "2025-11-01",
    author: "Chathero Team",
    category: "Vertrieb & Lead-Generierung",
    componentSet: "vertrieb-ihr-hoergeraet",
  },
];

 export const getCaseStudyPageBySlug = (slug: string): CaseStudyPage | undefined => {
   return caseStudyPages.find((page) => page.slug === slug);
 };
 
 export const getAllCaseStudySlugs = (): string[] => {
   return caseStudyPages.map((page) => page.slug);
 };